
<div class="inner-adjust">
    <div class="pt-3 pb-2 mb-3 border-bottom">
      <h1>Personnages</h1>
    </div>
    <!-- Show user data when logged in -->
    <div class="row">
      <div class="col-md-12">
        <div class="media">
          <div class="media-body">
            <ul class="list-unstyled">
              <li *ngFor="let personnage of personnages">
                {{ personnage.nom }} - 
                <a routerLink="/characterSheets/{{personnage.id}}"><i class="fas fa-user"></i>Modifier</a>
                <a style="padding-left: 10px" href="" (click)="confirmDelete(personnage)">[X]</a>
              </li>
            </ul>
            <button routerLink="/characterSheets/create" class="btn"><i class="fas fa-user"></i>Créer un nouveau personnage</button>
          </div>
        </div>
      </div>
    </div>
  </div>